export default __webpack_public_path__ + "static/media/kitchen3-after2-1920w.c7b6b609.avif";